import React, { useEffect, useState } from 'react';
import { makeStyles, Grid, TextField, Typography } from '@material-ui/core';
import InputMask from 'react-input-mask';

import styles from './styles';
import { Field } from 'formik';
import helpers from 'app/utils/helpers';

const useStyles = makeStyles(styles);

function ContactForm(props) {
    const classes = useStyles();

    const { formikBag, title, canEdit, isSurveyRegistration = false } = props;

    const { values, errors, touched } = formikBag;
    const [phoneMask, setPhoneMask] = useState('(99) 9999-99999');
    const [deTelefoneContato, setDeTelefoneContato] = useState(() => {
        return values?.deTelefoneContato ? values.deTelefoneContato : '';
    });

    useEffect(() => {
        setDeTelefoneContato(values?.deTelefoneContato);
    }, [values?.deTelefoneContato]);

    const changePhone = (e) => {
        const value = e.target.value;
        if (helpers.somenteNumeros(value).length >= 11) {
            setPhoneMask('(99) 99999-9999');
        } else {
            setPhoneMask('(99) 9999-99999');
        }
        setDeTelefoneContato(value);
        values.deTelefoneContato = value;
    };

    return (
        <Grid container spacing={2}>
            {!isSurveyRegistration && (<>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.title}>
                        {title}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Field
                        name="deContato"
                        label="Nome*"
                        variant="filled"
                        margin="dense"
                        fullWidth
                        error={!!errors.deContato}
                        helperText={errors.deContato && touched.deContato ? errors.deContato : ''}
                        as={TextField}
                        inputProps={{ maxLength: 90 }}
                        disabled={!canEdit}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={6}>
                    {canEdit ? (
                        <Field name="deTelefoneContato">
                            {({ field, form: { errors } }) => (
                                <InputMask
                                    mask={phoneMask}
                                    maskChar={' '}
                                    {...field}
                                    onChange={(e) => changePhone(e)}
                                    value={deTelefoneContato}>
                                    {() => (
                                        <TextField
                                            {...props}
                                            name="deTelefoneContato"
                                            label="Telefone*"
                                            variant="filled"
                                            margin="dense"
                                            fullWidth
                                            error={!!errors.deTelefoneContato}
                                            helperText={
                                                errors.deTelefoneContato && touched.deTelefoneContato
                                                    ? errors.deTelefoneContato
                                                    : ''
                                            }
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    )}
                                </InputMask>
                            )}
                        </Field>
                    ) : (
                        <TextField
                            label="Telefone*"
                            value={values?.deTelefoneContato}
                            variant="filled"
                            margin="dense"
                            disabled
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    )}
                </Grid>

                <Grid item xs={6}>
                    <Field
                        name="deEmailContato"
                        label="E-mail*"
                        variant="filled"
                        margin="dense"
                        fullWidth
                        error={!!errors.deEmailContato}
                        helperText={errors.deEmailContato && touched.deEmailContato ? errors.deEmailContato : ''}
                        as={TextField}
                        inputProps={{ maxLength: 90 }}
                        disabled={!canEdit}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </>)}

            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    multiline
                    minRows={4}
                    fullWidth
                    error={!!errors.deObservacao}
                    helperText={errors.deObservacao && touched.deObservacao ? errors.deObservacao : ''}
                    as={TextField}
                    inputProps={{ maxLength: 90 }}
                    disabled={!canEdit}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default ContactForm;
